
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import ContactShell from "@/src/layouts/ContactShell";
import Page from "@/src/components/Page";

const Contact = () => {
    return (
        <ContactShell/>
    );
};

const ContactPage = () => (
    <Page name="Contact" path="/contact/">
        <Contact/>
    </Page>
);

export default ContactPage;

    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/contact',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  